import { colors } from '@/styles';
import { PALLET_STATUSES } from '@/constants/manifestStatuses';

export const PALLET_STATUS_COLORS = {
    [PALLET_STATUSES.NOT_RECEIVED]: colors.reds.primary,
    [PALLET_STATUSES.RECEIVED]: colors.greens.primary,
    [PALLET_STATUSES.STORED]: colors.greens.primary,
    [PALLET_STATUSES.PICKED]: colors.blues[0],
    [PALLET_STATUSES.STAGED]: colors.blues[0],
    [PALLET_STATUSES.PICKED_UP]: colors.greens.primary,
};

export const INBOUND_MANIFEST_TYPES = new Set(['INBOUND', 'CROSS_DOCK']);
export const OUTBOUND_MANIFEST_TYPES = new Set(['OUTBOUND', 'WILL_CALL', 'RETURN_TO_SENDER']);

export const CONSOLIDATED_PALLET_TYPE = 'CONSOLIDATED';
